export default __webpack_public_path__ + "static/media/regulatory--no-turn-on-red--g3.9040df5f.png";